import React from "react";

const data = [
    {
        year: "2019",
        img: "/images/2019.png",
        title: "The team was founded",
        desc: "A bunch of text describing this year",
    },
    {
        year: "2021",
        img: "/images/2021.png",
        title: "First Time in Silverstone",
        desc: "A bunch of text describing this year",
    },
    {
        year: "2022",
        img: "/images/2022.png",
        title: "Second time in Silverstone",
        desc: "A bunch of text describing this year",
    },
    {
        year: "2024",
        img: "/images/2024.png",
        title: "Growth phase",
        desc: "A bunch of text describing this year",
    },
    {
        year: "2025",
        img: "/images/2025.png",
        title: "Big milestone",
        desc: "A bunch of text describing this year",
    },
    {
        year: "2026",
        img: "",
        title: "Future vision",
        desc: "                  As we look toward the 2026 season, RGU Motorsport is focused on pushing\n" +
            "                            the team further than ever before. With new members joining across\n" +
            "                            engineering and business roles, we aim to build on the knowledge and\n" +
            "                            experience gained in previous years.\n" +
            "                      \n" +
            "                        <br/>\n" +
            "                        \n" +
            "                            Our goal is to continue refining our design process, improving the\n" +
            "                            performance and reliability of our car, and strengthening the teamwork\n" +
            "                            that drives the project forward. Every season presents new challenges,\n" +
            "                            but it also provides an opportunity for innovation and growth.\n" +
            "                        \n" +
            "                        <br/>\n" +
            "                        \n" +
            "                            With the support of our partners and the dedication of our student team,\n" +
            "                            we are excited to see what we can achieve in 2026 as we continue our\n" +
            "                            journey in motorsport engineering.\n" +
            "                        \n" +
            "                    \n" +
            "               ",
    },
];

const TeamPhotosMobile: React.FC = () => {
    return (
        <section className="bg-black text-white py-16 px-6">
            <p className="text-center font-bold pb-4 text-2xl">Our History</p>

            <hr className=" pb-4" />

            <div className="max-w-2xl mx-auto relative">

                {/* Vertical line */}
                <div className="absolute left-4 top-0 bottom-0 w-[2px] bg-white/20" />

                <div className="space-y-16">
                    {data.map((item, index) => (
                        <div key={index} className="relative pl-12">

                            {/* Dot */}
                            <div className="absolute left-[6px] top-2 w-4 h-4 bg-white rounded-full border-4 border-black" />

                            {/* Year */}
                            <p className="text-sm text-white/60 mb-2">
                                {item.year}
                            </p>

                            {/* Card */}
                            <div className="bg-white/5 rounded-2xl overflow-hidden shadow-lg backdrop-blur-md">

                                {item.img && (
                                    <img
                                        src={item.img}
                                        alt={item.year}
                                        className="w-full h-48 object-cover"
                                    />
                                )}

                                <div className="p-4">
                                    <h3 className="text-lg font-semibold mb-2">
                                        {item.title}
                                    </h3>
                                    <p className="text-sm text-white/70">
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default TeamPhotosMobile;